import { GoogleProduct, MicrosoftService } from '@api/api/alfred-integrations';
import { create } from '@terminal/utils/store/createStore';

export const MICROSOFT_SERVICE_TOOL_GROUPS: Record<MicrosoftService, string> = {
  onedrive: 'alfred_integrations_onedrive',
  outlook: 'alfred_integrations_outlook',
  onenote: 'alfred_integrations_onenote',
  teams: 'alfred_integrations_teams',
};

export const NOTION_TOOL_GROUP = 'alfred_integrations_notion';

export const GOOGLE_SERVICE_TOOL_GROUPS: Record<GoogleProduct, string> = {
  google_calendar: 'alfred_integrations_google_calendar',
  google_drive: 'alfred_integrations_google_drive',
  google_docs: 'alfred_integrations_google_docs',
};

interface ConnectorsStore {
  disabledProviders: string[];
  disabledMicrosoftServices: MicrosoftService[];
  disabledNotion: boolean;
  disabledGoogleProducts: GoogleProduct[];
  setProviderEnabled: (providerId: string, enabled: boolean) => void;
  setMicrosoftServiceEnabled: (
    service: MicrosoftService,
    enabled: boolean
  ) => void;
  setNotionEnabled: (enabled: boolean) => void;
  setGoogleProductEnabled: (product: GoogleProduct, enabled: boolean) => void;
}

export const useConnectors = create<ConnectorsStore>(set => ({
  disabledProviders: [],
  disabledMicrosoftServices: [],
  disabledNotion: false,
  disabledGoogleProducts: [],
  setProviderEnabled: (providerId, enabled) => {
    set(state => {
      const others = state.disabledProviders.filter(id => id !== providerId);

      return {
        disabledProviders: enabled ? others : [...others, providerId],
      };
    });
  },
  setMicrosoftServiceEnabled: (service, enabled) => {
    set(state => {
      const others = state.disabledMicrosoftServices.filter(
        name => name !== service
      );

      return {
        disabledMicrosoftServices: enabled ? others : [...others, service],
      };
    });
  },
  setNotionEnabled: enabled => set({ disabledNotion: !enabled }),
  setGoogleProductEnabled: (product, enabled) => {
    set(state => {
      const others = state.disabledGoogleProducts.filter(
        name => name !== product
      );

      return {
        disabledGoogleProducts: enabled ? others : [...others, product],
      };
    });
  },
}));
